module.exports = __webpack_public_path__ + "img/F6.d7b58802.png";